<div class="annotation-popup" data-testid="annotation-popup"
  [class.mobile-drawer]="mobile"
  [class.arrow-left]="!hideArrow && arrowSide === 'left'"
  [class.arrow-right]="!hideArrow && arrowSide === 'right'"
  [class.arrow-top]="!hideArrow && arrowSide === 'top'"
  [class.arrow-bottom]="!hideArrow && arrowSide === 'bottom'"
  (mouseenter)="hovered.emit(true)"
  (mouseleave)="hovered.emit(false)">

  <div class="popup-arrow" *ngIf="!hideArrow"></div>

  <div class="popup-scroll">
    <!-- Header -->
    <div class="popup-header">
      <div class="header-title">
        <span class="label-dot" [style.background]="tag?.color"></span>
        <span class="label-name">{{ displayTitle || tag?.label }}</span>
        <span class="probability" *ngIf="probability != null">{{ probability * 100 | number:'1.0-0' }}%</span>
        <span class="author" *ngIf="tag?.author && tag?.author !== currentUserEmail">
          {{ 'tagging.popup.by' | translate }} {{ tag?.author }}
        </span>
      </div>
      <div class="header-actions">
        <button mat-icon-button class="edit-action" *ngIf="!disabled && probability != null" (click)="editTag.emit()"
          [matTooltip]="'tagging.popup.edit' | translate" data-testid="popup-edit">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button class="delete-action" *ngIf="!disabled" (click)="onDelete()"
          [matTooltip]="'tagging.popup.delete' | translate" data-testid="popup-delete">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button class="close-action" (click)="attemptClose()"
          [matTooltip]="'tagging.popup.close' | translate" data-testid="popup-close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Label picker -->
    <div class="popup-label-select" *ngIf="labels?.length && !hideFields">
      <lib-search-select
        [items]="labels"
        [label]="'Risque identifié'"
        [selectedItem]="selectedLabel"
        [valueKey]="'id'"
        [labelKey]="'name'"
        [searchPlaceholder]="'Rechercher un risque'"
        [disabled]="disabled || labelReadOnly"
        (itemChanged)="labelChanged.emit($event)">
      </lib-search-select>
    </div>

    <!-- Configured fields -->
    <div class="popup-body" *ngIf="!hideFields && labelProject?.optionalFields?.length" [class.multi-line-select]="hasMultiValue()">
      <lib-optional-fields
        [options]="fieldOptions()"
        [fields]="tag?.optionalFields || []"
        [label]="labelCatalogEntry || undefined"
        [disabled]="disabled"
        (change)="onFieldsChange($event)">
      </lib-optional-fields>
    </div>

    <!-- Comment -->
    <div class="popup-comment" *ngIf="!hideFields">
      <mat-form-field appearance="outline" class="comment-field">
        <mat-label>{{ 'risks.comment' | translate }}</mat-label>
        <textarea matInput rows="2" [ngModel]="comment" [disabled]="disabled"
          (ngModelChange)="commentChange.emit($event)"></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
